import React, { Component } from "react";
import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import SEO from "../../layout/SEO";
import ArticlesGrid from "../../layout/ArticlesGrid";

export default class VeilleArticles extends Component {
  componentDidMount() {
    window.resetScript();
  }

  render() {
    const { type } = this.props;
    const title = type === "VEILLE_JURIDIQUE" ? "Veille Juridique" : "Veille Technologique";
    const description = type === "VEILLE_JURIDIQUE" 
      ? "Articles de veille juridique sur les évolutions législatives et réglementaires."
      : "Articles de veille technologique sur les dernières innovations et tendances du web.";
    const breadcrumb = type === "VEILLE_JURIDIQUE" 
      ? [{ name: "Accueil", link: "/" }, { name: "Veille", link: "/veille" }, { name: "Veille Juridique", link: window.location.pathname }]
      : [{ name: "Accueil", link: "/" }, { name: "Veille", link: "/veille" }, { name: "Veille Technologique", link: window.location.pathname }];

    return (
      <>
        <SEO
          title={title}
          description={description}
          keywords={`${title.toLowerCase()}, veille, articles, ${type === "VEILLE_JURIDIQUE" ? "juridique, droit" : "technologie, innovation"}`}
        />
        <Header active="Veille" modeDark={true} />
        <BannerSimple title={title} boxElement={breadcrumb} />
        
        <section className="portfolio_details_area section-gap">
          <div className="container">
            <ArticlesGrid 
              type={type}
              itemsPerPage={12}
              emptyMessage="Aucun article de veille trouvé"
            />
          </div>
        </section>

        <Footer />
      </>
    );
  }
}

